module.exports = __webpack_public_path__ + "assets/events_disasters_plain.450ce419.svg";